import _ from 'lodash';
import * as types from 'actions/types';

const reducer = (state, action) => {
  switch (action.type) {
    case types.SET_JWT:
      return { ...state, ...action.payload };
    case types.SET_USER_ROLES:
      return { ...state, ...action.payload };
    case types.SET_USERS:
      return { ...state, ...action.payload };
    case types.SET_PRODUCTS:
      return { ...state, ...action.payload };
    case types.SET_PRODUCTS_FILTERS:
      return { ...state, ...action.payload };
    case types.SET_TEMPLATES:
      return _.merge(state.templates, action.payload);
    default:
      return state;
  }
};

export default reducer;
export const initialState = {};
